module.exports = __webpack_public_path__ + "img/346f279157890952ded0af8dfb28dd5b.png";